import { getIntelligenceCommonStyles } from './intelligence-common-style';

export const getBookingReportStyles = (_, { palette = {} }) => ({
  marginTop: 32,
  marginLeft: 32,

  '& .booking-report-container': {
    '& .form-group.title-container': {
      display: 'none',
    },

    '& .form-group.description-container': {
      marginBottom: 20,
    },

    '& .booking-report-download-button': {
      marginTop: 20,
    },

    '& .form-group': {
      '& .col-sm-1.control-label': {
        width: '100%',
        textAlign: 'left',
      },
    },
    '& .date-picker-container': {
      display: 'none',
    },
    ...getIntelligenceCommonStyles(_, { palette }),
  },
});
